import { render, staticRenderFns } from "./QuizTeacherDraft.vue?vue&type=template&id=5694c191&"
import script from "./QuizTeacherDraft.vue?vue&type=script&lang=js&"
export * from "./QuizTeacherDraft.vue?vue&type=script&lang=js&"
import style0 from "./QuizTeacherDraft.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports